var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.loading
    ? _c("div")
    : _c("div", { staticClass: "setting-channels" }, [
        _c(
          "div",
          { staticClass: "setting-channels__mode" },
          [
            _c("p", [_vm._v("Режим настройки")]),
            _vm._v(" "),
            _c(
              "InputRadio",
              {
                attrs: {
                  value: "simple",
                  modelValue: _vm.activeSetting,
                  name: "setting",
                },
                on: {
                  change: function ($event) {
                    return _vm.changeSetting("simple")
                  },
                },
              },
              [_vm._v("Простой")]
            ),
            _vm._v(" "),
            _c(
              "InputRadio",
              {
                attrs: {
                  value: "advanced",
                  modelValue: _vm.activeSetting,
                  name: "setting",
                },
                on: {
                  change: function ($event) {
                    return _vm.changeSetting("advanced")
                  },
                },
              },
              [_vm._v("Расширенный")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _vm.typeSettingNotify
          ? _c(
              "div",
              { staticClass: "setting-channels__simple" },
              [
                _c("p", [_vm._v("Каналы получения")]),
                _vm._v(" "),
                _vm._l(
                  _vm.settingNotify.channels_types,
                  function (type, index) {
                    return _c(
                      "SimpleCheckbox",
                      {
                        key: index,
                        attrs: {
                          checked: _vm.settingNotify.settings.find(
                            (item) => item.channel_name === type
                          )?.is_working,
                        },
                        on: {
                          change: function ($event) {
                            _vm.changeSimple(
                              type,
                              !_vm.settingNotify.settings.find(
                                (item) => item.channel_name === type
                              )?.is_working
                            )
                          },
                        },
                      },
                      [_vm._v(_vm._s(type))]
                    )
                  }
                ),
              ],
              2
            )
          : _c(
              "div",
              {
                staticClass: "setting-channels__advanced",
                style: ` grid-template-columns: 520px repeat(${
                  _vm.settingNotify?.channels_types &&
                  _vm.settingNotify.channels_types.length
                }, 1fr);`,
              },
              [
                [
                  _c("div", { staticClass: "row-table__name" }),
                  _vm._v(" "),
                  _vm._l(_vm.settingNotify.channels_types, function (name) {
                    return _c(
                      "div",
                      { key: name, staticClass: "row-table__cell" },
                      [_vm._v("\n        " + _vm._s(name) + "\n      ")]
                    )
                  }),
                ],
                _vm._v(" "),
                _vm._l(_vm.settingNotify.settings, function (item) {
                  return [
                    _c(
                      "div",
                      {
                        key: item.section_id,
                        staticClass: "row-table__name",
                        on: {
                          click: function ($event) {
                            return _vm.clickActiveRow(item.section_name)
                          },
                        },
                      },
                      [
                        _c("AppIcon", {
                          staticClass: "arrow-block",
                          class: {
                            "arrow-block_active": _vm.activeRow.includes(
                              item.section_name
                            ),
                          },
                          attrs: { src: "@icons/arrow-open.svg" },
                        }),
                        _vm._v(
                          "\n        " + _vm._s(item.section_name) + "\n      "
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm._l(
                      _vm.settingNotify.channels_types,
                      function (type, index) {
                        return _c("SwitchInput", {
                          key: item.section_id + index,
                          staticClass: "row-table__cell",
                          attrs: {
                            checked: !item.notifications.filter(
                              (notifiy) => !notifiy.channels.includes(type)
                            ).length,
                          },
                          on: {
                            change: function ($event) {
                              _vm.changeChannelsList({
                                id: item.section_id,
                                type: type,
                                value: item.notifications.filter(
                                  (item) => !item.channels.includes(type)
                                ).length,
                              })
                            },
                          },
                        })
                      }
                    ),
                    _vm._v(" "),
                    _vm.activeRow.includes(item.section_name) &&
                    !!item.section_name.length
                      ? [
                          _vm._l(item.notifications, function (childItem) {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "row-table__name row-table__name-child",
                                },
                                [_vm._v(_vm._s(childItem.notification_name))]
                              ),
                              _vm._v(" "),
                              _vm._l(
                                _vm.settingNotify.channels_types,
                                function (type, index) {
                                  return _c("SwitchInput", {
                                    key: index,
                                    staticClass: "row-table__cell",
                                    attrs: {
                                      checked:
                                        childItem.channels.includes(type),
                                    },
                                    on: {
                                      change: function ($event) {
                                        _vm.changeChannelsItem({
                                          section_id: item.section_id,
                                          id: childItem.notification_id,
                                          type: type,
                                          value:
                                            !childItem.channels.includes(type),
                                        })
                                      },
                                    },
                                  })
                                }
                              ),
                            ]
                          }),
                        ]
                      : _vm._e(),
                  ]
                }),
              ],
              2
            ),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }